import * as R from 'ramda';

export default function CompletedAssessmentController(
  $q,
  $scope,
  $rootScope,
  alerts,
  bcpDataService,
  confirmDialog,
  editTestDialog,
  loaderService,
  ssDialogService,
  bcpEditAssessmentDocumentDialog,
  userService
) {
  const vm = this;

  vm.isExpanded = false;
  vm.hasData = false;
  vm.loaderService = loaderService;
  vm.handleExpandAssessment = _handleExpandAssessment;
  vm.handleAddTest = _handleAddTest;
  vm.handleUnapprove = _handleUnapprove;
  vm.handleDelete = _handleDelete;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  vm.handleAttachDocument = _handleAttachDocument;
  vm.handleDownloadAllDocuments = _handleDownloadAllDocuments;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    const dfdActivate = $q.defer();
    _initEventListeners();
    _initPermissions();
    dfdActivate.resolve();
  }

  function _initEventListeners() {
    $scope.$on('refreshBCPAssessmentDocuments', (event, opt) => {
      if (opt.assessmentId === vm.assessment.assessmentId) {
        _refreshAssessmentDocuments();
      }
    });
  }

  function _initPermissions() {
    vm.canExpand = true;
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
      vm.permissions.canAttachDocuments = vm.assessment.canAttachDocuments;
    });
  }

  function _handleExpandAssessment() {
    if (!vm.hasData) {
      vm.loaderService.showViewLoader = true;
      bcpDataService.getTests(
        vm.assessment.assessmentId
      ).then((getTestsResponse) => {
        vm.hasData = true;
        vm.tests = getTestsResponse.data.result;
        vm.isExpanded = true;
        vm.loaderService.showViewLoader = false;
      });
    } else {
      vm.isExpanded = !vm.isExpanded;
    }
  }

  function _handleAddTest($event) {
    ssDialogService.dialogs.bcp.editTestDialog = ssDialogService.alert(
      editTestDialog.getOptions($event, {
        assessmentId: vm.assessment.assessmentId,
        testTypes: $rootScope.testTypes,
        test: {
          assessmentTestId: 0,
          testDocuments: [],
        }
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editTestDialog);
  }

  // Unapprove Assessment

  function _handleUnapprove($event) {
    ssDialogService.dialogs.bcp.unapproveCompletedAssessmentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Unapprove Plan?',
        message: `Are you sure you want to Unapprove Plan "${vm.assessment.name}"? This will make the Plan
         active again."`,
        handleYesClick: _handleConfirmUnapprove,
        handleNoClick: _handleCancelUnapprove,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.bcp.unapproveCompletedAssessmentConfirmDialog);
  }

  function _handleConfirmUnapprove() {
    loaderService.showViewLoader = true;
    return bcpDataService.unapproveAssessment(vm.assessment.assessmentId).then(() => {
      alerts.success('The Plan has been unapproved successfully.');
      $rootScope.$broadcast('refreshBCPAssessments');
      _closeUnapproveDialog();
    }).catch(() => {
      alerts.error('An error occurred unapproving the Plan.');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _handleCancelUnapprove() {
    _closeUnapproveDialog();
  }

  function _closeUnapproveDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.unapproveCompletedAssessmentConfirmDialog);
  }

  // Delete Assessment

  function _handleDelete($event) {
    ssDialogService.dialogs.bcp.deleteCompletedAssessmentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Assessment?',
        message: `Are you sure you want to delete Plan "${vm.assessment.name}"?"`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.bcp.deleteCompletedAssessmentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return bcpDataService.deleteAssessment(vm.assessment.assessmentId).then(() => {
      alerts.success('The Plan has been deleted successfully.');
      $rootScope.$broadcast('refreshBCPAssessments');
      _closeDeleteDialog();
    }).catch(() => {
      alerts.error('An error occurred deleting the Plan.');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.deleteCompletedAssessmentConfirmDialog);
  }

  function _handleAttachDocument($event) {
    ssDialogService.dialogs.bcp.editDocumentAttachmentDialog = ssDialogService.alert(
      bcpEditAssessmentDocumentDialog.getOptions($event, {
        assessment: vm.assessment,
        document: {
          assessmentDocumentId: 0,
          deletable: true,
        },
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editDocumentAttachmentDialog);
  }

  function _handleDownloadAllDocuments() {
    loaderService.showViewLoader = true;
    bcpDataService.downloadAllAssessmentDocuments(vm.assessment.assessmentId).then((response) => {
      _handleDownload(response);
    });
  }

  function _handleDownload(response) {
    alerts.success('The file download will start momentarily.');
    const contentDisposition = response.headers('Content-Disposition');

    if (!R.isNil(contentDisposition)) {
      const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/g.exec(contentDisposition);
      vm.downloadName = matches && matches.length > 1 ? matches[1] : null;
      vm.downloadName = vm.downloadName.split('"').join('');
    }

    const blob = new Blob(
      [response.data],
      { type: 'application/x-zip-compressed', }
    );

    // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, vm.downloadName);
    } else {
      const anchor = document.createElement('a');
      document.body.appendChild(anchor);
      anchor.setAttribute('type', 'hidden');

      anchor.href = URL.createObjectURL(blob);
      anchor.download = vm.downloadName;
      anchor.target = '_self';
      anchor.click();
    }

    loaderService.showViewLoader = false;
  }

  function _refreshAssessmentDocuments() {
    loaderService.showViewLoader = true;
    return bcpDataService.getAssessmentDocumentsByAssessment(vm.assessment.assessmentId).then((response) => {
      vm.assessment.assessmentDocuments = response.data.result;
      vm.documentsLoaded = true;
      loaderService.showViewLoader = false;
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }
}

CompletedAssessmentController.$inject = [
  '$q',
  '$scope',
  '$rootScope',
  'alerts',
  'bcpDataService',
  'confirmDialog',
  'editTestDialog',
  'loaderService',
  'ssDialogService',
  'bcpEditAssessmentDocumentDialog',
  'userService'
];
